import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  wells: "/wells",
  wellbores: "/wellbores",
  logsObserver: "/logs-observer",
  logs: "/logs",
  cementJobs: "/cement-job",
  stimJobs: "/stim-jobs",
  geometry: "/geometry",
  systems: "/units/systems",
  measures: "/units/measures",
  units: "/units",
  convertFormula: "/convert-formula",
};

const endpointsSlice = createSlice({
  name: "endpoints",
  initialState,
  reducers: {},
});

export const {} = endpointsSlice.actions;
export default endpointsSlice.reducer;
